const type = 'RESET_BANK_ACCOUNT_SEARCH_BY_ID_RESULTS';

const resetCustomersSearchByCards = () => ({
  type,
});

export default resetCustomersSearchByCards;
